import React, { createContext, useContext, useEffect, useState } from "react";
import { getFolderOptions } from "../services/apiServices";

const AnalyticsFilterContext = createContext(null);

export const AnalyticsFilterProvider = ({ children }) => {
  const [selectedFolder, setSelectedFolder] = useState("All");
  const [folderOptions, setFolderOptions] = useState([]);
  const [loadingFolders, setLoadingFolders] = useState(false);

  useEffect(() => {
    const loadFolders = async () => {
      try {
        setLoadingFolders(true);
        const loggedInUserDetails = JSON.parse(localStorage.getItem("loggedInUserDetails"));
        if (!loggedInUserDetails?.Name) return;

        const data = await getFolderOptions(loggedInUserDetails.Name);

        const names = Array.isArray(data)
          ? data.map((f) => f.folder_name)
          : [];

        setFolderOptions(names);
      } catch (err) {
        console.error("Failed to load folder options", err);
        setFolderOptions([]);
      } finally {
        setLoadingFolders(false);
      }
    };

    loadFolders();
  }, []);

  return (
    <AnalyticsFilterContext.Provider
      value={{
        selectedFolder,
        setSelectedFolder,
        folderOptions,
        loadingFolders,
        setFolderOptions
      }}
    >
      {children}
    </AnalyticsFilterContext.Provider>
  );
};

export const useAnalyticsFilters = () => {
  const ctx = useContext(AnalyticsFilterContext);
  if (!ctx) {
    throw new Error(
      "useAnalyticsFilters must be used inside AnalyticsFilterProvider"
    );
  }
  return ctx;
};
